import React from 'react';
import { Helmet } from "react-helmet";

const BnaProgramRecieved = () => {
    return (
        <div>
            <Helmet>
                <title>S-Mom</title>
                <meta name="title" content="S-Mom" />
                <meta name="description" content="" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="" />
                <meta property="og:description" content="" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="" />
            </Helmet>
            <div id="pageBnaProgramRecieved">
                <main>
                    {/* Logo */}
                    <div className="bna-program-logo">
                        <div className="bna-program-logo-image"></div>
                    </div>
                    {/* Message Section */}
                    <div className="message-section">
                        <div className="message-text">
                            <h4>บัญชี LINE นี้</h4>
                            <br />
                            <p>เคยได้รับสินค้าตัวอย่างแล้ว</p>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default BnaProgramRecieved;
